module.exports = __webpack_public_path__ + "static/media/img178.af1acd22.jpg";